// utils/translations.js
const translations = {
    fr: {
        accessApp: "Accès à l'application",//
        accountRequired: "L'utilisation de l'application requiert la création d'un compte utilisateur.",//
        usernameOrEmail: "Pseudo ou adresse email",//
        password: "Mot de passe",//
        connecting: "Connexion...",//
        login: "Se connecter",//
        forgotPassword: "J'ai oublié mon mot de passe !",//
        username: "Pseudo",//
        email: "Adresse email",//
        confirmPassword: "Confirmer le mot de passe",//
        captchaLabel: "Je ne suis pas un robot",//
        iHaveRead: "J'ai lu et j'accepte les",
        termsAndConditions: " conditions générales d'utilisation du service",//
        and: ", incluant notre ",
        privacy: "politique de confidentialité",
        register: "S'inscrire",//
        noAccount: "Vous n'avez pas de compte ?",//
        createAccount: "Créez-en un gratuitement !",//
        alreadyHaveAccount: "Vous avez déjà un compte ?",//
        goToLogin: "Connectez-vous",//
        invalidCredentials: "Identifiant ou mot de passe incorrect.",//
        serverError: "Erreur serveur. Réessayez plus tard.",//
        invalidUsernameFormat: "Le pseudo ne doit contenir que des lettres, chiffres, tirets ou underscores.",//
        usernameTaken: "Ce pseudo est déjà utilisé.",//
        invalidEmailFormat: "L'adresse email n'est pas valide.",//
        emailTaken: "Cette adresse email est déjà utilisée.",
        passwordTooShort: "Le mot de passe doit contenir au moins 12 caractères.",//
        passwordMissingUppercase: "Le mot de passe doit contenir au moins une majuscule.",//
        passwordMissingLowercase: "Le mot de passe doit contenir au moins une minuscule.",//
        passwordMissingNumber: "Le mot de passe doit contenir au moins un chiffre.",//
        passwordMissingSpecial: "Le mot de passe doit contenir au moins un caractère spécial.",//
        confirmPasswordRequired: "Veuillez confirmer votre mot de passe.",//
        passwordMismatch: "Les mots de passe ne correspondent pas.",//
        captchaRequired: "Veuillez cocher la case captcha.",//
        acceptTermsRequired: "Veuillez accepter les conditions d'utilisation du service.",//
        registrationError: "Erreur lors de l'inscription.",//
        fixErrorsBeforeSubmit: "Corrigez les erreurs avant de soumettre.",//
        postalCode: "Code postal",
        postalCodeRequired: "Le code postal est requis.",
        invalidPostalCode: "Code postal invalide.",
        countryRequired: "Veuillez sélectionner un pays dans la liste.",
    },
    en: {
        accessApp: "Access the application",
        accountRequired: "Using the application requires creating a user account.",
        usernameOrEmail: "Username or email address",
        password: "Password",
        connecting: "Connecting...",
        login: "Log in",
        forgotPassword: "I forgot my password!",
        username: "Username",
        email: "Email address",
        confirmPassword: "Confirm password",
        captchaLabel: "I'm not a robot",
        iHaveRead: "I have read and accept the ",
        termsAndConditions: "terms of service",
        and: ", including our ",
        privacy: "privacy policy",
        register: "Sign up",
        noAccount: "Don't have an account?",
        createAccount: "Create one for free!",
        alreadyHaveAccount: "Already have an account?",
        goToLogin: "Log in",
        invalidCredentials: "Invalid username or password.",
        serverError: "Server error. Please try again later.",
        invalidUsernameFormat: "Username can only contain letters, numbers, hyphens, or underscores.",
        usernameTaken: "This username is already taken.",
        invalidEmailFormat: "The email address is not valid.",
        emailTaken: "This email address is already taken.",
        passwordTooShort: "Password must be at least 12 characters long.",
        passwordMissingUppercase: "Password must contain at least one uppercase letter.",
        passwordMissingLowercase: "Password must contain at least one lowercase letter.",
        passwordMissingNumber: "Password must contain at least one number.",
        passwordMissingSpecial: "Password must contain at least one special character.",
        confirmPasswordRequired: "Please confirm your password.",
        passwordMismatch: "Passwords do not match.",
        captchaRequired: "Please check the captcha box.",
        acceptTermsRequired: "Please accept the terms of service.",
        registrationError: "Error during registration.",
        fixErrorsBeforeSubmit: "Fix the errors before submitting.",
        postalCode: "Postal code",
        postalCodeRequired: "Postal code is required.",
        invalidPostalCode: "Invalid postal code.",
        countryRequired: "Please select a country from the list.",
    },
    de: {
        accessApp: "Zugriff auf die Anwendung",
        accountRequired: "Die Nutzung der Anwendung erfordert die Erstellung eines Benutzerkontos.",
        usernameOrEmail: "Benutzername oder E-Mail-Adresse",
        password: "Passwort",
        connecting: "Verbinden...",
        login: "Anmelden",
        forgotPassword: "Ich habe mein Passwort vergessen!",
        username: "Benutzername",
        email: "E-Mail-Adresse",
        confirmPassword: "Passwort bestätigen",
        captchaLabel: "Ich bin kein Roboter",
        iHaveRead: "Ich habe gelesen und akzeptiere die ",
        termsAndConditions: "Nutzungsbedingungen",
        and: ", einschließlich unserer ",
        privacy: "Datenschutzrichtlinie",
        register: "Registrieren",
        noAccount: "Sie haben noch kein Konto?",
        createAccount: "Erstellen Sie kostenlos eines!",
        alreadyHaveAccount: "Haben Sie bereits ein Konto?",
        goToLogin: "Anmelden",
        invalidCredentials: "Ungültiger Benutzername oder Passwort.",
        serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
        invalidUsernameFormat: "Der Benutzername darf nur Buchstaben, Zahlen, Bindestriche oder Unterstriche enthalten.",
        usernameTaken: "Dieser Benutzername ist bereits vergeben.",
        invalidEmailFormat: "Die E-Mail-Adresse ist ungültig.",
        emailTaken: "Diese E-Mail-Adresse wird bereits verwendet.",
        passwordTooShort: "Das Passwort muss mindestens 12 Zeichen lang sein.",
        passwordMissingUppercase: "Das Passwort muss mindestens einen Großbuchstaben enthalten.",
        passwordMissingLowercase: "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.",
        passwordMissingNumber: "Das Passwort muss mindestens eine Zahl enthalten.",
        passwordMissingSpecial: "Das Passwort muss mindestens ein Sonderzeichen enthalten.",
        confirmPasswordRequired: "Bitte bestätigen Sie Ihr Passwort.",
        passwordMismatch: "Die Passwörter stimmen nicht überein.",
        captchaRequired: "Bitte bestätigen Sie das Captcha.",
        acceptTermsRequired: "Bitte akzeptieren Sie die Nutzungsbedingungen.",
        registrationError: "Fehler bei der Registrierung.",
        fixErrorsBeforeSubmit: "Bitte beheben Sie die Fehler, bevor Sie fortfahren.",
        postalCode: "Postleitzahl",
        postalCodeRequired: "Postleitzahl ist erforderlich.",
        invalidPostalCode: "Ungültige Postleitzahl.",
        countryRequired: "Bitte wählen Sie ein Land aus der Liste aus.",
    },
    es: {
        accessApp: "Acceso a la aplicación",
        accountRequired: "El uso de la aplicación requiere la creación de una cuenta de usuario.",
        usernameOrEmail: "Nombre de usuario o correo electrónico",
        password: "Contraseña",
        connecting: "Conectando...",
        login: "Iniciar sesión",
        forgotPassword: "¡Olvidé mi contraseña!",
        username: "Nombre de usuario",
        email: "Correo electrónico",
        confirmPassword: "Confirmar contraseña",
        captchaLabel: "No soy un robot",
        iHaveRead: "He leído y acepto los ",
        termsAndConditions: "términos del servicio",
        and: ", incluyendo nuestra ",
        privacy: "política de privacidad",
        register: "Registrarse",
        noAccount: "¿No tienes una cuenta?",
        createAccount: "¡Crea una gratis!",
        alreadyHaveAccount: "¿Ya tienes una cuenta?",
        goToLogin: "Inicia sesión",
        invalidCredentials: "Nombre de usuario o contraseña incorrectos.",
        serverError: "Error del servidor. Inténtelo de nuevo más tarde.",
        invalidUsernameFormat: "El nombre de usuario solo puede contener letras, números, guiones o guiones bajos.",
        usernameTaken: "Este nombre de usuario ya está en uso.",
        invalidEmailFormat: "La dirección de correo electrónico no es válida.",
        emailTaken: "Esta dirección de correo electrónico ya está en uso.",
        passwordTooShort: "La contraseña debe tener al menos 12 caracteres.",
        passwordMissingUppercase: "La contraseña debe contener al menos una letra mayúscula.",
        passwordMissingLowercase: "La contraseña debe contener al menos una letra minúscula.",
        passwordMissingNumber: "La contraseña debe contener al menos un número.",
        passwordMissingSpecial: "La contraseña debe contener al menos un carácter especial.",
        confirmPasswordRequired: "Por favor, confirma tu contraseña.",
        passwordMismatch: "Las contraseñas no coinciden.",
        captchaRequired: "Por favor, marca la casilla del captcha.",
        acceptTermsRequired: "Por favor, acepta los términos del servicio.",
        registrationError: "Error durante el registro.",
        fixErrorsBeforeSubmit: "Corrige los errores antes de enviar.",
        postalCode: "Código postal",
        postalCodeRequired: "El código postal es obligatorio.",
        invalidPostalCode: "Código postal no válido.",
        countryRequired: "Por favor, selecciona un país de la lista.",
    },
    it: {
        accessApp: "Accesso all'applicazione",
        accountRequired: "L'utilizzo dell'applicazione richiede la creazione di un account utente.",
        usernameOrEmail: "Nome utente o indirizzo email",
        password: "Password",
        connecting: "Connessione...",
        login: "Accedi",
        forgotPassword: "Ho dimenticato la mia password!",
        username: "Nome utente",
        email: "Indirizzo email",
        confirmPassword: "Conferma password",
        captchaLabel: "Non sono un robot",
        iHaveRead: "Ho letto e accetto i ",
        termsAndConditions: "termini di servizio",
        and: ", inclusa la nostra ",
        privacy: "politica sulla privacy",
        register: "Registrati",
        noAccount: "Non hai un account?",
        createAccount: "Creane uno gratuitamente!",
        alreadyHaveAccount: "Hai già un account?",
        goToLogin: "Accedi",
        invalidCredentials: "Nome utente o password non validi.",
        serverError: "Errore del server. Riprova più tardi.",
        invalidUsernameFormat: "Il nome utente può contenere solo lettere, numeri, trattini o underscore.",
        usernameTaken: "Questo nome utente è già in uso.",
        invalidEmailFormat: "L'indirizzo email non è valido.",
        emailTaken: "Questo indirizzo email è già in uso.",
        passwordTooShort: "La password deve contenere almeno 12 caratteri.",
        passwordMissingUppercase: "La password deve contenere almeno una lettera maiuscola.",
        passwordMissingLowercase: "La password deve contenere almeno una lettera minuscola.",
        passwordMissingNumber: "La password deve contenere almeno un numero.",
        passwordMissingSpecial: "La password deve contenere almeno un carattere speciale.",
        confirmPasswordRequired: "Conferma la tua password.",
        passwordMismatch: "Le password non corrispondono.",
        captchaRequired: "Seleziona la casella captcha.",
        acceptTermsRequired: "Accetta i termini di servizio.",
        registrationError: "Errore durante la registrazione.",
        fixErrorsBeforeSubmit: "Correggi gli errori prima di inviare.",
        postalCode: "Codice postale",
        postalCodeRequired: "Il codice postale è obbligatorio.",
        invalidPostalCode: "Codice postale non valido.",
        countryRequired: "Seleziona un paese dall'elenco, per favore.",
    }
};

export default translations;
